import React from 'react'

import { cn } from '@/lib/utils.ts'

const Skeleton: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => <div className={`rounded bg-gray-200 ${className}`} {...props} />

export const DocumentSkeleton = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        `grid aspect-square size-full animate-pulse auto-rows-fr grid-cols-6 gap-[2%] p-[2%]`,
        className
      )}
      style={{ fontSize: 'min(1.5vw, 1.5vh)' }}
      {...props}
    >
      {/* Header */}
      <Skeleton className="col-span-6 row-span-1" />
      <Skeleton className="col-span-4 row-span-1" />

      {/* First Paragraph */}
      <Skeleton className="col-span-6 row-span-1" />
      <Skeleton className="col-span-6 row-span-1" />
      <Skeleton className="col-span-5 row-span-1" />

      {/* Table */}
      <div className="col-span-6 row-span-4 grid grid-cols-4 grid-rows-4 gap-[2%]">
        {Array.from({ length: 16 }).map((_, index) => (
          <Skeleton key={index} className="size-full" />
        ))}
      </div>

      {/* Second Paragraph */}
      <Skeleton className="col-span-3 row-span-1" />
      <Skeleton className="col-span-3 row-span-1" />
      <Skeleton className="col-span-2 row-span-1" />

      {/* List */}
      <div className="col-span-3 row-span-3 grid grid-rows-3 gap-[2%]">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className="flex items-center gap-[2%]">
            <Skeleton className="aspect-square w-[5%] shrink-0 rounded-full" />
            <Skeleton className="h-full grow" />
          </div>
        ))}
      </div>

      {/* Third Paragraph */}
      <Skeleton className="col-span-6 row-span-1" />
      <Skeleton className="col-span-6 row-span-1" />
      <Skeleton className="col-span-4 row-span-1" />
    </div>
  )
})

DocumentSkeleton.displayName = 'DocumentSkeleton'
